/**
 * src/i18n/services/DirectionSwitcher.ts
 *
 * Direction switcher with scroll preservation and opacity flash guard.
 * Prevents layout jumps and disorientation when switching between LTR and RTL.
 */

export class DirectionSwitcher {
  /**
   * Applies LTR or RTL text direction while preserving window and container scroll positions.
   */
  public static setDirection(dir: 'ltr' | 'rtl'): void {
    if (typeof document === 'undefined') return;

    // 1. Snapshot scroll positions
    const scrollX = window.scrollX || document.documentElement.scrollLeft || 0;
    const scrollY = window.scrollY || document.documentElement.scrollTop || 0;

    // 2. Brief opacity flash guard
    const body = document.body;
    const prevTransition = body.style.transition;
    body.style.opacity = '0.98';

    // 3. Apply direction to HTML element
    document.documentElement.dir = dir;
    document.documentElement.setAttribute('dir', dir);

    // 4. Restore scroll positions smoothly in the next animation frame
    requestAnimationFrame(() => {
      window.scrollTo(scrollX, scrollY);
      requestAnimationFrame(() => {
        body.style.opacity = '1';
        body.style.transition = prevTransition;
      });
    });
  }
}
